import { ArrowLeftOutlined } from "@ant-design/icons";
import { Select } from "antd";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import WeldParameterTab from "./WeldParameterTab";
import { fetchWeldParametersRequest } from "../../redux/data360Live_WeldParameter/action";
import ErrorBanner from "../Common/ErrorBanner";
import CommonLoader from "../Loaders/loader";

const WeldParameterMain = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [selectedMachineJob, setSelectedMachineJob] = useState(null);
  const dispatch = useDispatch();
  const currentProject = useSelector(
    (state) => state?.data360LiveProjectReducer?.currentProject
  );
  const weldParameters = useSelector(
    (state) => state.data360LiveWeldParameterReducer?.data
  );
  const isLoading = useSelector(
    (state) => state.data360LiveWeldParameterReducer?.loading
  );
  const weldParameterErrors = useSelector(
    (state) => state.data360LiveWeldParameterReducer?.weldParameterErrors
  );

  // Extract error messages from weldParameterErrors
  const getErrorMessages = () => {
    if (
      !weldParameterErrors?.errors ||
      weldParameterErrors.errors.length === 0
    ) {
      return [];
    }

    // Only show errors if selected machine is not m500
    if (
      selectedMachineJob &&
      selectedMachineJob.machine &&
      selectedMachineJob.machine.toLowerCase() === "m500"
    ) {
      return [];
    }

    // Filter errors by the currently selected job number and machine
    const currentJobNumber = selectedMachineJob?.jobData?.job_number;
    const currentMachine = selectedMachineJob?.machine;

    if (!currentJobNumber || !currentMachine) {
      return [];
    }

    const errorMessages = [];
    weldParameterErrors.errors.forEach((error) => {
      // Check if the error belongs to the currently selected job and machine
      if (
        error.job_number === currentJobNumber &&
        error.welding_system === currentMachine &&
        error.parsedErrors?.errorMessages
      ) {
        errorMessages.push(...error.parsedErrors.errorMessages);
      }
    });

    return errorMessages;
  };

  const errorMessages = getErrorMessages();

  const getMachineJobOptions = () => {
    if (!weldParameters?.groupedByMachine) return [];

    const options = [];

    Object.entries(weldParameters.groupedByMachine).forEach(
      ([machine, jobs]) => {
        jobs.forEach((job) => {
          options.push({
            value: `${machine}:${job.job_number}`,
            label: `${machine.toUpperCase()}: ${job.job_number}`,
            machine,
            jobData: job,
          });
        });
      }
    );

    return options;
  };

  const handleMachineJobChange = (value) => {
    const selectedOption = getMachineJobOptions().find(
      (opt) => opt.value === value
    );
    setSelectedMachineJob(selectedOption);

    // Set default active tab based on machine
    if (selectedOption) {
      if (selectedOption.machine === "p625") {
        setActiveTab("1");
      } else if (selectedOption.machine === "m500") {
        setActiveTab("1");
      } else {
        setActiveTab("1");
      }
    }
  };

  useEffect(() => {
    const project_id = currentProject?.project_id;
    if (project_id) {
      dispatch(
        fetchWeldParametersRequest({
          project_id,
        })
      );
    }
  }, [dispatch, currentProject]);

  // Automatically select the first option when weldParameters are loaded
  useEffect(() => {
    setSelectedMachineJob(getMachineJobOptions()[0]);
    if (weldParameters?.groupedByMachine && !selectedMachineJob) {
      const options = getMachineJobOptions();
      if (options.length > 0) {
        handleMachineJobChange(options[0].value);
      }
    }
  }, [weldParameters]);

  if (isLoading) {
    return (
      <div className="slogdata-loader">
        <CommonLoader />
      </div>
    );
  }
  return (
    <>
      <div className="weld-parameter-main">
        <Link
          to={"/data360Live"}
          style={{ display: "flex", alignItems: "center" }}
        >
          <div className="back_equip-unActive">
            <ArrowLeftOutlined />
            <h2 className="weld-header">Weld Parameters</h2>
          </div>
        </Link>

        <div className="status-table-limit">
          <span className="select-job-no">Select Machine/Job : </span>
          <Select
            placeholder="Select Machine/Job"
            style={{ width: 300 }}
            onChange={handleMachineJobChange}
            options={getMachineJobOptions()}
            value={selectedMachineJob?.value}
          />
        </div>
      </div>
      <ErrorBanner errors={errorMessages} />
      <WeldParameterTab
        setActiveTab={setActiveTab}
        selectedMachineJob={selectedMachineJob}
        activeTab={activeTab}
      />
    </>
  );
};

export default WeldParameterMain;
